import { GetQuoteListByOrderIdResponsePayload } from '@schuettflix/interfaces';
import { CurrencyCode } from '@schuettflix/utils';
import { FulfillmentQuote } from '../context/FulfillmentContext';
import { Price } from '@schuettflix/conversion';
import { z } from 'zod';

export type PayloadQuote = Pick<
    z.infer<typeof GetQuoteListByOrderIdResponsePayload>['payload'],
    | 'id'
    | 'name'
    | 'amount'
    | 'orderProductId'
    | 'unit'
    | 'currencyCode'
    | 'partnerOrganizationId'
    | 'orderingOrganizationId'
    | 'platformOrganizationId'
    | 'purchasePrice'
    | 'purchaseTaxClassId'
    | 'salesPrice'
    | 'salesTaxClassId'
    | 'serviceDate'
    | 'freightType'
    | 'disposalPurpose'
>;

export function mapToFulfillmentQuote(quote: PayloadQuote): FulfillmentQuote {
    return {
        ...quote,
        currencyCode: quote.currencyCode as CurrencyCode,
        purchasePrice: new Price(quote.purchasePrice, quote.currencyCode as CurrencyCode),
        salesPrice: new Price(quote.salesPrice, quote.currencyCode as CurrencyCode),
        serviceDate: quote.serviceDate?.toISOString(),
        freightType: quote.freightType ?? undefined,
        disposalPurpose: quote.disposalPurpose ?? undefined,
    };
}
